export default __webpack_public_path__ + "static/media/avi.366fd0a0.svg";